import React from 'react';

import type { SvgIconClassKey } from '@mui/material';
import { SvgIcon } from '@mui/material';

import { IconColors } from './icon-utils';

export function NarrowMarginsIcon(props: {
  classes?: Partial<Record<SvgIconClassKey, string>>;
}): JSX.Element {
  return (
    <SvgIcon
      classes={props.classes}
      style={{ display: 'block', height: 39, width: 32 }}
      viewBox="0 0 32 39"
    >
      <g fill="none" fillRule="evenodd">
        <rect fill="#FFF" height="38" rx="3" stroke={IconColors.Grey} width="31" x=".5" y=".5" />
        <g stroke="#146EE8">
          <path d="M2.5 0v36.999M30 34.499H0M30 2.499H0" transform="translate(1 1)" />
          <path d="M27.5 0v36.999" opacity=".994" transform="translate(1 1)" />
        </g>
      </g>
    </SvgIcon>
  );
}
